import React from 'react';

import { IFormDataInPaystatement } from 'types/salary';

interface IProps {
  NAME: string;
  PAYDATA: IFormDataInPaystatement;
  HandlePayInput: (e: React.ChangeEvent<HTMLInputElement>, isSecondDefaultPay?: boolean) => void; //금액입력
  handlePay: (e: React.KeyboardEvent<HTMLInputElement>, isSecondDefaultPay?: boolean) => void;
  isMinus?: boolean;
  plusMinusToggle?: (name: string) => void;
}

const SectionSumInput = ({
  NAME,
  PAYDATA,
  HandlePayInput,
  handlePay,
  isMinus = false,
  plusMinusToggle = (NAME) => {},
}: IProps) => {
  let VALUE = PAYDATA[NAME] ?? '0';

  return (
    <div className="SectionSumInput">
      {(NAME == '건강보험료 정산' || NAME == '고용보험 정산' || NAME == '국민연금 정산') && (
        <div className="SectionSumType">
          <button className={!isMinus ? 'isActive' : ''} onClick={() => plusMinusToggle(NAME)}>
            +
          </button>
          <button className={isMinus ? 'isActive' : ''} onClick={() => plusMinusToggle(NAME)}>
            -
          </button>
        </div>
      )}
      <input
        type="text"
        name={NAME}
        className={
          NAME == '기본급' && PAYDATA[NAME] == '0'
            ? 'W90, RB'
            : NAME == '건강보험료 정산' || NAME == '고용보험 정산' || NAME == '국민연금 정산'
            ? 'W70'
            : 'W90'
        }
        maxLength={15}
        value={VALUE}
        onChange={HandlePayInput}
        onKeyUp={handlePay}
        // onBlur={() => paySaveAndDeducCalculate(PAYDATA, PayType, false)}
      />
    </div>
  );
};

export default SectionSumInput;
